import { Box } from "@mui/system";
import { ColorRing } from "react-loader-spinner";

interface Props {
  height: string;
  width: string;
  colors: [string, string, string, string, string];
  textInfo: string;
}

export default function DefaultLoader({ height, width, colors, textInfo }: Props) {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)", // semi-transparent background
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999, // high z-index to ensure it's above everything
        pointerEvents: 'all', // Enable interaction with the loader
      }}
    >
      <div style={{ display: "flow", pointerEvents: 'none' }}>
        <div style={{ pointerEvents: 'all' }}>
          <ColorRing
            visible={true}
            height={height}
            width={width}
            ariaLabel="color-ring-loading"
            wrapperStyle={{}}
            wrapperClass="color-ring-wrapper"
            colors={colors}
          />
        </div>
        <div style={{ pointerEvents: 'all' }}>{textInfo}... aguarde!</div>
      </div>
    </div>
  );
}
